import { Spin } from 'antd';
import React from 'react';

type Props = {
    title: string;
    url: string;
};

const CommonVideo: React.FC<Props> = ({ title, url }) => {
    return (
        <div className="relative overflow-hidden w-full" style={{ zIndex: 1, paddingTop: '50%' }}>
            <iframe
                className="common-iframe z-10"
                src={url}
                allow="autoplay; fullscreen"
                frameBorder="4"
                allowFullScreen={true}
                title={title}
            />
            <div
                className="absolute h-20 w-20 justify-center items-center flex z-0"
                style={{ top: '38%', left: '38%' }}
            >
                <Spin size="large" className="video_loader" />
            </div>
        </div>
    );
};

export default CommonVideo;
